import {GlobalStyle} from "../../stemjs/src/ui/GlobalStyle.js";
import {ContestPanel} from "../../contest/js/ContestWidget.jsx";
import {Button} from "../../stemjs/src/ui/button/Button.jsx";
import {IEEEXtremeTopLevelContestNavigationHandler} from "./IEEEXtremeTopLevelContestNavigationHandler.jsx";
import {IEEEXtremeContestSummary} from "./IEEEXtremeContestSummary.jsx";
import {IEEEXtremeScoreboard} from "./IEEEXtremeScoreboard.jsx";
import {IEEEXtremeContestTasksList} from "./IEEEXtremeContestTasksTable.jsx";
import {isPreXtreme} from "./Constants.js";
import {Level} from "../../stemjs/src/ui/Constants.js";
import {Ajax} from "../../stemjs/src/base/Ajax.js";

export class IEEEXtremeContestPanel extends ContestPanel {
    getURLPrefix(str) {
        let url = "/" + this.getContest().name + "/";
        if (str) {
            url += str + "/";
        }
        return url;
    }

    constructor(...args) {
        super(...args);
        this.navHandler = new IEEEXtremeTopLevelContestNavigationHandler(this.getContest(), this);
    }

    getSummaryPanel() {
        return <IEEEXtremeContestSummary contest={this.getContest()}/>;
    }

    getScoreboardPanel() {
        const contest = this.getContest();
        return contest.canShowScoreboard() &&
            <IEEEXtremeScoreboard ref={this.refLink("scoreboard")}
                                  contest={this.getBaseContest()}
                                  virtualContest={this.getVirtualContest()}
                                  originalContest={contest}/>
    }

    getTasksListPanel() {
        const contest = this.getContest();
        const contestUser = contest.getOwnUser();

        if (isPreXtreme(contest) && contest.isRunning() && contestUser.timeRegistered < contest.startTime) {
            const startTimer = async () => {
                await Ajax.postJSON("/request_prextreme_start");
                window.location.reload(true);
            }

            return <div style={{margin:"auto", maxWidth: 640}} ref={this.refLink("contestTaskList")}>
                <h2>
                    You need to start the countdown to be able to solve the
                    problems. After you start you'll have 6 hours to make
                    submissions.
                </h2>
                <div style={{textAlign:"center", maxWidth: 480, marginTop: 24}}>
                    <Button level={Level.PRIMARY} onClick={startTimer}>
                        Start solving
                    </Button>
                </div>
            </div>;
        }
        return <IEEEXtremeContestTasksList
            ref={this.refLink("contestTaskList")}
            contest={contest}
            isArchive={false}
            className={GlobalStyle.Container.SMALL}
        />;
    }
}
